module.exports = __webpack_public_path__ + "static/media/not-our-light.b298ed48.svg";